// All menu data sourced from the brief. Each item maps to its hosted asset URL.
// Categories order = the order presented in the UI (sticky nav + sections).

const A = "https://customer-assets.emergentagent.com/job_smashed-delivery/artifacts";

export const MENU_CATEGORIES = [
  {
    id: "beef-burgers",
    name: "Beef Burgers",
    tagline: "Hand-smashed, double-stacked, fresh off the flat-top.",
    items: [
      { name: "Smash Cheeseburger", price: "10.50",
        desc: "Classic double-smashed beef, American cheese, pickles, house sauce in a toasted brioche.",
        image: `${A}/6ulc5fku_SoBe%20Cheese%20Burger.jpg` },
      { name: "Smoky BBQ Cheeseburger", price: "10.95",
        desc: "Smashed beef, melted cheese, crispy onions and smoky house BBQ.",
        image: `${A}/teppxgb2_BBQ%20Cheeseburger.png` },
      { name: "Double Bacon Cheeseburger", price: "12.99",
        desc: "Two smashed patties, double cheese, streaky bacon, house sauce.",
        image: `${A}/ci4dlt2h_Double%20Bacon%20Cheeseburger.png` },
      { name: "Green Chilli Cheeseburger", price: "11.95",
        desc: "Smashed beef, melted cheese, charred green chillies, chilli mayo.",
        image: `${A}/6rpwl87i_Green%20Chilli.png` },
      { name: "Confit Garlic Cheeseburger", price: "11.95",
        desc: "Smashed beef, melted cheese, slow-confit garlic, confit mayo.",
        image: `${A}/ccfrgrbv_Confit%20Garlic.jpg` },
      { name: "Truffle Cheeseburger", price: "11.95",
        desc: "Smashed beef, double cheese, truffle mayo, crispy shallots.",
        image: `${A}/i5ytfb9v_OG%20Truffle.jpg` },
      { name: "Double Hosin Cheeseburger", price: "12.99",
        desc: "Double smashed beef, melted cheese, sticky hoisin glaze, spring onion.",
        image: `${A}/ypla5j8e_Double%20Hosin%20Cheeseburger.png` },
    ],
  },
  {
    id: "chicken-burgers",
    name: "Chicken Burgers",
    tagline: "Buttermilk-brined, crisp-fried, never frozen.",
    items: [
      { name: "Signature Chicken Burger", price: "9.50",
        desc: "Our flagship buttermilk-fried chicken, slaw, pickles, house sauce.",
        image: `${A}/u79d1xwe_OG%20Chicken.jpg` },
      { name: "Crispy Chicken Classic", price: "6.99",
        desc: "Crispy fried chicken thigh, lettuce, mayo, in a toasted bun.",
        image: `${A}/1ef4tke8_Classic%20Chicken.png` },
      { name: "Smoky BBQ Chicken", price: "6.99",
        desc: "Fried chicken, melted cheese, crispy onions, smoky BBQ.",
        image: `${A}/bv5n7do9_BBQ%20Chicken.png` },
      { name: "Buffalo Chicken Burger", price: "10.50",
        desc: "Fried chicken, hot buffalo glaze, blue cheese mayo, slaw.",
        image: `${A}/tpajqi3j_Cajun%20BBQ%20Chicken.jpg` },
      { name: "Cajun BBQ Chicken Burger", price: "10.50",
        desc: "Cajun-dusted fried chicken, cheese, smoky BBQ, pickles.",
        image: `${A}/tpajqi3j_Cajun%20BBQ%20Chicken.jpg` },
      { name: "Honey Fire Chicken Burger", price: "10.50",
        desc: "Fried chicken glazed in our signature hot honey, slaw, pickles.",
        image: `${A}/sa90x90b_Hot%20Honey%20Chicken.png` },
    ],
  },
  {
    id: "vegan-burgers",
    name: "Vegan Burgers",
    tagline: "Big flavour, plant-based, no compromise.",
    items: [
      { name: "Vegan Cheeseburger", price: "8.50",
        desc: "Plant-based smashed patty, vegan cheese, pickles, vegan house sauce.",
        image: `${A}/m91xg8jj_Vegan%20Cheeseburger.png` },
    ],
  },
  {
    id: "baos",
    name: "Baos",
    tagline: "Pillowy steamed buns, packed with serious filling.",
    items: [
      { name: "House Bao", price: "6.50",
        desc: "Crispy chicken, slaw, house sauce, spring onion.",
        image: `${A}/k6xoym6i_OG%20Bao.png` },
      { name: "Katsu Bao", price: "6.50",
        desc: "Panko-fried chicken, katsu curry sauce, pickled slaw.",
        image: `${A}/2xbpf39k_Katsu%20Bao.png` },
      { name: "Honey Fire Bao", price: "6.50",
        desc: "Crispy chicken glazed in hot honey, slaw, spring onion.",
        image: `${A}/xrh7hd8w_Hot%20Honey%20Bao.png` },
      { name: "Sweet Chilli Bao", price: "6.50",
        desc: "Crispy chicken, sweet chilli glaze, fresh herbs.",
        image: `${A}/3prega42_Sweet%20Chilli%20Bao.png` },
      { name: "Hoisin Beef Bao", price: "4.50",
        desc: "Sticky hoisin beef, cucumber, spring onion, sesame.",
        image: `${A}/0h308935_Hoisin%20Beef%20Bao.png` },
      { name: "Korean Beef Bao", price: "4.50",
        desc: "Bulgogi-style beef, kimchi mayo, spring onion.",
        image: `${A}/4wth8y0q_Korean%20Beef%20Bao.png` },
      { name: "Buldak Bao", price: "4.50",
        desc: "Fire-spiced Korean chicken, kewpie mayo, sesame, scallion.",
        image: `${A}/nfz97qhx_Buldak%20Bao.png` },
      { name: "Pulled Hoisin Mushroom Bao", price: "4.50",
        desc: "Slow-pulled mushroom in sticky hoisin, cucumber, spring onion.",
        image: `${A}/880vbcte_Pulled%20Hoisin%20Mushroom%20Bao.png` },
      { name: "Pulled Korean Mushroom Bao", price: "4.50",
        desc: "Korean-spiced pulled mushroom, kimchi mayo, scallion.",
        image: `${A}/ed5023c9_Pulled%20Mushroom%20Korean%20Bao.png` },
    ],
  },
  {
    id: "rice-bowls",
    name: "Rice Bowls",
    tagline: "Sticky rice, big proteins, real flavour.",
    items: [
      { name: "Signature KFB Rice Bowl", price: "11.00",
        desc: "Crispy fried chicken, sticky rice, slaw, house sauce, sesame.",
        image: `${A}/78h15dzi_OG%20KFB%20Rice%20Bowl.png` },
      { name: "Honey Fire Chicken Rice Bowl", price: "11.00",
        desc: "Hot-honey glazed chicken on sticky rice, slaw, spring onion.",
        image: `${A}/kepimdwp_Hot%20Honey%20Rice.png` },
      { name: "Katsu Chicken Rice Bowl", price: "11.00",
        desc: "Panko chicken, katsu curry, sticky rice, pickled slaw.",
        image: `${A}/wc0h6wtn_Katsu%20Chicken%20Rice.png` },
      { name: "Hoisin Beef Rice Bowl", price: "11.00",
        desc: "Sticky hoisin beef, sticky rice, cucumber, sesame, scallion.",
        image: `${A}/ez4e7b53_Hoising%20Beef%20Rice%20Bowl.png` },
      { name: "Hot Honey Halloumi Rice Bowl", price: "11.00",
        desc: "Crispy halloumi, hot honey glaze, sticky rice, slaw.",
        image: `${A}/3mkheob1_Hot%20Honey%20Hallumi%20rice.png` },
      { name: "Hoisin Mushroom Rice Bowl", price: "11.00",
        desc: "Pulled hoisin mushroom, sticky rice, cucumber, sesame.",
        image: `${A}/4gvg1kd1_Hoisin%20Mushroom%20Rice%20Bowl.png` },
    ],
  },
  {
    id: "wings-tenders",
    name: "Wings & Tenders",
    tagline: "Crispy, juicy, glazed however you want them.",
    items: [
      { name: "Hot Honey Wings", price: "2.50", desc: "Per wing. Crispy, glazed in our signature hot honey.",
        image: `${A}/bl00prrd_Hot%20Honey%20Wings.png` },
      { name: "Cajun BBQ Wings", price: "2.50", desc: "Per wing. Cajun-dusted, BBQ-glazed.",
        image: `${A}/ouynxgc7_Cajun%20BBQ%20Wings.png` },
      { name: "Buffalo Wings", price: "2.50", desc: "Per wing. Classic hot buffalo glaze.",
        image: `${A}/p5j3o32l_Buffalo%20Wings.png` },
      { name: "Regular Tenders", price: "4.99", desc: "Buttermilk-fried chicken tenders, served with house sauce.",
        image: `${A}/a5134px7_Regular%20Tenders.png` },
      { name: "Large Tenders", price: "6.99", desc: "Larger portion of buttermilk-fried tenders, served with house sauce.",
        image: `${A}/40a5uvbh_Large%20Tenders.png` },
      { name: "Korean Wings (6 pcs)", price: "5.99", desc: "Korean-style crispy wings, sticky soy-garlic glaze.",
        image: `${A}/mhi5f7d2_Korean%20Wings.png` },
      { name: "Korean BBQ Wings (6 pcs)", price: "5.99", desc: "Korean wings in sticky BBQ glaze.",
        image: `${A}/llzbnkk9_Korean%20BBQ%20Wings.png` },
      { name: "Korean Hot Honey Wings (6 pcs)", price: "6.99", desc: "Korean wings in our hot-honey glaze.",
        image: `${A}/godyhdg5_Korean%20Hot%20Honey%20wings.png` },
    ],
  },
  {
    id: "karage",
    name: "Karage Chicken",
    tagline: "Japanese-style fried bites. Crispy. Crunchy. Insane.",
    items: [
      { name: "Salt and Pepper Chicken Karage", price: "3.00", desc: "Crispy karage tossed in salt & pepper seasoning.",
        image: `${A}/2qmvggdi_Salt%20Pepper%20Chicken%20Karaage.png` },
      { name: "Hot Honey Chicken Karage", price: "3.00", desc: "Crispy karage glazed in our hot honey.",
        image: `${A}/d8yx4nup_Hot%20Honey%20Chicken%20Karaage.png` },
      { name: "Sweet and Sour Chicken Karage", price: "3.00", desc: "Crispy karage in a sticky sweet & sour glaze.",
        image: `${A}/j1cmzhz3_Sweet%20and%20Sour%20Chicken%20Karrage.png` },
      { name: "Buldak Chicken Karage", price: "3.00", desc: "Korean-fire-spiced crispy karage.",
        image: `${A}/epfhwfxw_Buldak%20Chicken%20Karaage.png` },
    ],
  },
  {
    id: "fries",
    name: "Fries & Loaded Fries",
    tagline: "Skin-on, double-fried, loaded the right way.",
    items: [
      { name: "Fries", price: "2.99", desc: "Skin-on, double-fried, perfectly salted.",
        image: `${A}/phqwo19m_SoBe%20Fries.png` },
      { name: "Loaded Fries", price: "4.99", desc: "Fries, melted cheese, house sauce, crispy bits.",
        image: `${A}/phqwo19m_SoBe%20Fries.png` },
      { name: "Cajun Fries", price: "3.00", desc: "Skin-on fries dusted in Cajun seasoning.",
        image: `${A}/t7t2au98_Cajun%20Fries.png` },
      { name: "House Hot Fries", price: "3.50", desc: "Fries tossed in our fiery house spice.",
        image: `${A}/q1bd6dsv_Sobe%20Hot%20Fries.png` },
      { name: "House Fries", price: "4.25", desc: "Loaded with house sauce and crispy toppings.",
        image: `${A}/phqwo19m_SoBe%20Fries.png` },
      { name: "Garlic Mayo Fries", price: "3.50", desc: "Fries drizzled in roasted garlic mayo.",
        image: `${A}/l4wy1usl_Garlic%20Mayo%20Fries.png` },
      { name: "Truffle Fries", price: "3.95", desc: "Fries, truffle mayo, parmesan, herbs.",
        image: `${A}/b3l0w231_Truffle%20Fries.png` },
      { name: "House Spiced Fries", price: "3.50", desc: "Fries tossed in our signature spice blend.",
        image: `${A}/jjflxjtz_House%20Spiced%20Fries.png` },
      { name: "Katsu Curry Fries", price: "4.00", desc: "Fries loaded with rich katsu curry sauce.",
        image: `${A}/m9xizi7u_Katsu%20Curry%20Fries.png` },
      { name: "Hoisin Beef Fries", price: "6.50", desc: "Fries piled with sticky hoisin beef and sesame.",
        image: `${A}/58ju1657_Hoisin%20Beef%20Fries.png` },
      { name: "Korean BBQ Waffle Fries", price: "4.99", desc: "Crispy waffle fries with Korean BBQ glaze.",
        image: `${A}/84uwz3sr_Korean%20BBQ%20Waffle%20fries.png` },
      { name: "Waffle Fries", price: "4.50", desc: "Crispy seasoned waffle-cut fries.",
        image: `${A}/rg0cjp9p_Waffle%20Fries.png` },
      { name: "Spicy Loaded Waffle Fries", price: "5.95", desc: "Waffle fries loaded with cheese, chilli and house sauce.",
        image: `${A}/hgerd74x_Spicy%20Loaded%20Waffle%20Fries.png` },
    ],
  },
  {
    id: "sides",
    name: "Sides & Sauces",
    tagline: "The little extras that finish the feast.",
    items: [
      { name: "Spicy Asian Slaw", price: "2.00", desc: "Crunchy slaw with chilli and lime.",
        image: `${A}/lw98417u_Spricy%20Asian%20Slaw.png` },
      { name: "House Sauce Dip Pot", price: "1.00", desc: "Our signature house sauce.",
        image: `${A}/2jtrsrk8_SoBe%20Sauce.png` },
      { name: "BBQ Sauce", price: "1.00", desc: "Smoky house BBQ.",
        image: `${A}/rcramgc0_BBQ%20Sauce.png` },
      { name: "Truffle Mayo", price: "1.00", desc: "Rich, earthy truffle mayo.",
        image: `${A}/lghi3il0_Truffle%20Mayo.png` },
      { name: "Hot Honey Sauce", price: "1.00", desc: "Sticky, sweet and fiery.",
        image: `${A}/9dxwj76p_Hot%20Honey%20Sauce.png` },
      { name: "Hot Sauce", price: "1.00", desc: "Pure heat.",
        image: `${A}/bng9ukko_Hot%20Sauce.png` },
      { name: "Confit Mayo", price: "1.00", desc: "Slow-cooked garlic mayo.",
        image: `${A}/uz6yk2as_Confit%20Mayo.png` },
      { name: "Chilli Mayo", price: "1.00", desc: "Creamy mayo with a chilli kick.",
        image: `${A}/7vlts05s_Chili%20Mayo.png` },
    ],
  },
  {
    id: "desserts",
    name: "Desserts",
    tagline: "Finish the feast on a sweet note.",
    items: [
      { name: "Brownie Bites", price: "4.99", desc: "Warm chocolate brownie bites, gooey middle.",
        image: `${A}/xvfritzv_Brownie%20Bites.png` },
      { name: "Churros", price: "4.99", desc: "Cinnamon-sugar churros, chocolate dip.",
        image: `${A}/lktvxu8m_Churros.png` },
    ],
  },
  {
    id: "drinks",
    name: "Drinks",
    tagline: "Cold cans, big bottles, all the classics.",
    items: [
      { name: "Water", price: "1.50", desc: "Still bottled water.",
        image: `${A}/6ylnn8t1_Water.jpg` },
      { name: "Coca Cola (Can)", price: "1.99", desc: "Classic Coke, ice-cold.",
        image: `${A}/y95d94mf_Coca%20Cola.png` },
      { name: "Diet Coke (Can)", price: "1.99", desc: "Diet Coke can.",
        image: `${A}/lsv7olg0_Diet%20Coke.png` },
      { name: "Pepsi (Can)", price: "1.99", desc: "Pepsi can.",
        image: `${A}/6vfpmdvo_Pepsi.png` },
      { name: "Pepsi Max (Can)", price: "1.99", desc: "Pepsi Max can.",
        image: `${A}/47yo6ykk_Pepsi%20Max.png` },
      { name: "Dr Pepper (Can)", price: "1.99", desc: "Dr Pepper can.",
        image: `${A}/uqxw4r10_Dr%20Pepper.png` },
      { name: "Fanta (Can)", price: "1.99", desc: "Fanta Orange can.",
        image: `${A}/6y529x4n_Fanta.png` },
      { name: "Rio (Can)", price: "1.99", desc: "Rio Tropical can.",
        image: `${A}/jz3rxv7n_Rio.png` },
      { name: "Sprite (Can)", price: "1.99", desc: "Sprite can.",
        image: `${A}/gjxyjz4w_Sprite.png` },
      { name: "Tango Apple (Can)", price: "1.99", desc: "Tango Apple can.",
        image: `${A}/47t1jnd2_Tango%20Apple.png` },
      { name: "Coca Cola 1.5L", price: "3.99", desc: "Sharing-size bottle.",
        image: `${A}/qprsl79d_Coca%20Cola%201.5L.png` },
      { name: "Diet Coke 1.5L", price: "3.99", desc: "Sharing-size bottle.",
        image: `${A}/0emnz3d3_Diet%20Coke%201.5L.png` },
      { name: "Pepsi 1.5L", price: "3.99", desc: "Sharing-size bottle.",
        image: `${A}/id00f7qr_Pepsi%201.5L.png` },
      { name: "Tango Orange 1.5L", price: "3.99", desc: "Sharing-size bottle.",
        image: `${A}/ouh4t0u3_Tango%20Orange%201.5L.png` },
    ],
  },
];

// Hero feature images (used for the hero stack)
export const HERO_IMAGES = {
  main: `${A}/i5ytfb9v_OG%20Truffle.jpg`,
  secondary: `${A}/2xbpf39k_Katsu%20Bao.png`,
  tertiary: `${A}/ez4e7b53_Hoising%20Beef%20Rice%20Bowl.png`,
};
